var _path, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtraHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25.001H20C20.663 25.001 21.2989 24.7376 21.7678 24.2688C22.2366 23.7999 22.5 23.164 22.5 22.501V11.251C22.501 11.0865 22.4694 10.9234 22.4072 10.7711C22.345 10.6188 22.2534 10.4803 22.1375 10.3635L12.1375 0.363491C11.9033 0.130677 11.5865 0 11.2563 0C10.926 0 10.6092 0.130677 10.375 0.363491L0.375 10.3635C0.25689 10.4793 0.162927 10.6173 0.0985566 10.7697C0.0341858 10.922 0.000686563 11.0856 0 11.251V22.501C0 23.164 0.263392 23.7999 0.732233 24.2688C1.20107 24.7376 1.83696 25.001 2.5 25.001ZM8.75 22.501V16.251H13.75V22.501H8.75ZM2.5 11.7635L11.25 3.01349L20 11.7635V22.501H16.25V16.251C16.25 15.5879 15.9866 14.9521 15.5178 14.4832C15.0489 14.0144 14.413 13.751 13.75 13.751H8.75C8.08696 13.751 7.45107 14.0144 6.98223 14.4832C6.51339 14.9521 6.25 15.5879 6.25 16.251V22.501H2.5V11.7635Z",
    fill: "#5A2D00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 10.501,
    width: 6,
    height: 13,
    fill: "#5A2D00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5352,
    y: 2.50098,
    width: 7.11244,
    height: 13,
    transform: "rotate(45.5808 11.5352 2.50098)",
    fill: "#5A2D00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5947,
    y: 24.499,
    width: 7.09265,
    height: 14.1272,
    transform: "rotate(178.973 21.5947 24.499)",
    fill: "#5A2D00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.27344,
    y: 14.2026,
    width: 6.45468,
    height: 14.1272,
    transform: "rotate(-90.2054 5.27344 14.2026)",
    fill: "#5A2D00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 10.501,
    width: 6,
    height: 13,
    fill: "#5A2D00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraHeader);
export default __webpack_public_path__ + "static/media/extra-header.a278fa9316fc12fd79f87ff2bd2d4e2f.svg";
export { ForwardRef as ReactComponent };